import { Link } from 'react-router';

import { RULE_SET_COPY } from './ruleSetCopy';
export const CARRIER_NOT_FOUND_MESSAGE = 'این مورد پیدا نشد. ممکن است متعلق به اپراتور دیگری باشد؛ اپراتور را از بالای صفحه بررسی کنید.';

export default function CarrierRulesMissing({ domain, carrier, canEdit, variant = 'admin' }) {
  const copy = RULE_SET_COPY[domain];
  if (!carrier || !copy) return null;
  return <section className={`carrier-rules-missing carrier-rules-missing-${variant}`} role="alert" dir="rtl">
    <h2>{copy.title} برای {carrier.brand_name} تعریف نشده است.</h2>
    <p>{copy.consequence}</p>
    {canEdit && carrier ? <Link className="carrier-button" to={`/admin/carrier/${domain}?carrier=${encodeURIComponent(carrier.slug)}`}>
      رفتن به پروفایل اپراتور</Link> : <p>از مدیر سامانه بخواهید این قواعد را منتشر کند.</p>}
  </section>;
}
